// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"timer__wrapper__1nfvv","timerText":"timer__timerText__IeSPW"};